import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import classnames from "classnames";
import { useClickTracker } from "web/react/hooks/use-click-tracker/use-click-tracker";
import LazyLoadImage from "web/react/components/lazy-load-image/lazy-load-image";
import Rail from "web/react/components/rail/rail";
import styles from "./featured-banners.css";

interface FeaturedBannersItem {
    url: string;
    image_url: string;
    title: string;
    text: string;
    cta_text: string;
}

interface FeaturedBannersProps {
    banner_rows: FeaturedBannersItem[][];
}

export function FeaturedBannerItem({
    title,
    text,
    cta_text: ctaText,
    url,
    image_url: imgUrl,
}: FeaturedBannersItem): JSX.Element {
    const eventCategory = "featured banner homepage";
    const eventAction = "clicked";
    const textOnClick = useClickTracker(eventCategory, eventAction, `text: ${text}`);
    const imageOnClick = useClickTracker(eventCategory, eventAction, `image: ${text}`);

    return (
        <div className={styles.featuredItem}>
            <a href={url} onClick={imageOnClick} role="presentation">
                <LazyLoadImage className={styles.featuredImage} src={imgUrl} role="presentation" />
            </a>

            <a href={url} onClick={textOnClick}>
                <h3 className={styles.title}>{title}</h3>
                <p className={styles.teaser}>{text}</p>
                <span className={styles.ctaLink}>
                    {ctaText} <SVGIcon className={styles.chevron} name="chevron" />
                </span>
            </a>
        </div>
    );
}

function FeaturedBanners({ banner_rows: bannerRows }: FeaturedBannersProps): JSX.Element {
    const leftButtonStyle = classnames(styles.scrollButton, styles.left);
    const rightButtonStyle = classnames(styles.scrollButton, styles.right);

    return (
        <div className={styles.featuredBannersWrap}>
            <Rail
                title={""}
                analyticsLabel={"featured-banners"}
                leftButtonStyle={leftButtonStyle}
                rightButtonStyle={rightButtonStyle}
                buttonIcon={"square-chevron"}
                className={styles.featuredBanners}
            >
                {bannerRows.map((row) =>
                    row.map((item) => <FeaturedBannerItem key={item.url} {...item} />)
                )}
            </Rail>
        </div>
    );
}

export default FeaturedBanners;
